import React, {useEffect, useState} from "react";
import {DeleteItemsApi} from "../../../../reduxToolkit/Commons/CommonsApi";
import {useDispatch, useSelector} from "react-redux";
import { SimpleSearch} from "../../../../reduxToolkit/Search/SearchApi";
import {useTranslation} from "react-i18next";
import {MODELS} from "../../../../Apis/Models";
import {TABLES} from "../../../../Apis/Tables";
import CustomTh from "../../../../components/table/CustomTh";
import {getDeviceAccessTypeById, getIconClassesContainer} from "../Model/Model";
import {getDeviceTypeById} from "../../../../hooks/deviceTypeEnum";
import CustomTd from "../../../../components/table/CustomTd";
import CustomImageTable from "../../../../components/CustomImageTable";
import CustomTooltip from "../../../../components/CustomTooltip";
import deviceTypeId from "../../../../hooks/deviceTypeId";
import CustomChip from "../../../../components/CustomChip";
import {statusBorderColor, statusColor, statusFontColor} from "../../../../enums/statusColorEnum";
import {status, STATUS_MODEL} from "../../../../enums/statusEnum";
import {permissionObj} from "../../../../Helpers/permission";
import DropDownMenuProfile from "../../../../components/DropDown/DropDownMenuProfile";
import DropDownMenuItem from "../../../../components/DropDown/DropDownMenuItem";
import routes from "../../../../Routes/routes";
import {DeleteIconsOptions, IconTitleEntryMethod, UpdateIconsOptions,IconFileLog} from "../../../../components/buttons/IconButtons";
import {colors} from "../../../../enums/colors";
import TableFunction from "../../../../components/table/TableFunction";
import {EMPTY_VALUES, errorMsg} from "../../../../Apis/functions";
import {
    DEFAULT_LEFT,
    LEFT_FIRST_COLUMN_WITH_CHECKBOX,
    SEARCH_MODEL
} from "../../../../components/table/Model/TableModel";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import {useNavigate} from "react-router-dom";


/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 */

/**
 * Custom hook used to manage the devices panel view.
 *
 * This hook handles:
 * - Device listing.
 * - Device deletion.
 * - Device search.
 * - Table rendering.
 * - Bulk selection.
 * - QR download handling.
 * - Device actions dropdown.
 * - Device log modal state.
 * - Open door modal state.
 * - Pagination integration.
 *
 * @function DevicesPanelApp
 *
 * @returns {Object} Hook response object.
 */
export const DevicesPanelApp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [modified, setModified] = useState(false);
    const { t } = useTranslation();
    const [deleteDeviceShow, setDeleteDeviceShow] = useState(false);
    const [openDoorShow, setOpenDoorShow] = useState(false);
    const [itemOpenDoor, setItemOpenDoor] = useState(null);
    const [showDeleteDeviceModal, setShowDeleteDeviceModal] = useState(false);
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [bodyForExport, setBodyForExport] = useState(null);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    // useSelector
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);

    // Search simple for Devices Panel (only name)
    const [searchElement, setSearchElement] = useState('');
    const tableId = "tbl_dpa_devices";
    const searchId = "txt_dpa_search_devices";
    const [qrName, setQrName] = useState(null);
    const [results, setResults] = useState(null);
    const [qrData, setQrData] = useState(null);
    const [logDevice, setLogDevice] = useState();
    const [showLogModal, setShowLogModal] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    // Props to the filter window
    const moduleId = `${MODELS.Devices}`;
    const option = `${TABLES.DEVICES}`;
    const deletePermission = (DEV || permission?.includes(permissionObj?.WEB_DEVICE_DELETE));
    const leftPosition = deletePermission ? LEFT_FIRST_COLUMN_WITH_CHECKBOX : DEFAULT_LEFT;

    const deleteSelectedDevices = (deleteItem) => {
        const body = deleteItem;
        if (body.length > 0) {
            dispatch(DeleteItemsApi({ tableName: option, body })).then(
                ({
                     payload: {
                         data: { success, code },
                     },
                 }) => {
                    if (success === true) {
                        setModified(true);
                        setSelectedList([]);
                        setIsAllChecked(false);
                    } else
                        setModified(true);
                        setSelectedList([]);
                        setIsAllChecked(false);
                        errorMsg(code);
                },
            );
        }
    };

    const downloadQRCode = () => {
        const canvas = document?.getElementById('qr-gen');

        if (canvas) {
            const pngUrl = canvas.toDataURL('image/png').replace('image/png', 'image/octet-stream');
            let downloadLink = document?.createElement('a');
            downloadLink.href = pngUrl;

            downloadLink.download = `qr_code_${qrName}.png`;
            document?.body.appendChild(downloadLink);
            downloadLink.click();
            document?.body.removeChild(downloadLink);
        }
    };

    useEffect(() => {
        if (qrData) {
            downloadQRCode();
        }
    }, [qrData]);

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} fixedXY={true} left={leftPosition} classes="first_head">{t('name')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('ip')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('mac')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('s/n')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('device_type_table')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('access_type_table')}</CustomTh>,
            <CustomTh tableId={tableId} >{t('status')}</CustomTh>,
            <CustomTh tableId={tableId} className='zone-th'>{t('zone')}</CustomTh>
        ];
    }

    const getTbody = () => {
        if(!results || results?.content?.length === 0) return {
            body: [],
            data: []
        };

        let iconClassContainer = getIconClassesContainer(results?.content);

        let body = results?.content?.map((item) => {
            let deviceAccessType = getDeviceAccessTypeById(item?.deviceAccessTypeId);
            let deviceType = getDeviceTypeById(item?.deviceTypeId);

            return (
                <>
                    <CustomTd tableId={tableId} fixed={true} left={leftPosition} classes={"first-column"}>
                        <CustomTooltip
                            text={item?.name}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId} >{item?.ip || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >{item?.mac || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId} >
                        <CustomTooltip
                            text={item?.serialNumber || EMPTY_VALUES.DEFAULT}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomImageTable
                            tooltip={t(deviceTypeId(item?.deviceTypeId))}
                            children={<span className="text-ellipsis text-left">{t(deviceType.trans)}</span>}
                            containerClass={"d-flex align-items-center"}
                            icon={<div className={`mr-2 `}>{deviceType.icon && (<deviceType.icon  width={30}/>)}</div>}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomImageTable
                            children={<span className="text-ellipsis text-left">{t(deviceAccessType?.trans)}</span>}
                            tooltip={t(deviceAccessType?.trans)}
                            containerClass={"d-flex align-items-center"}
                            icon={<div className={`${iconClassContainer} ${deviceAccessType.color} mr-2`}><deviceAccessType.Icon /></div>}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[item?.statusId]}
                            fontColor={statusFontColor[item?.statusId]}
                            borderColor={statusBorderColor[item?.statusId]}
                            legend={t(status[item?.statusId]) || EMPTY_VALUES.DEFAULT}
                            variant={'large'}
                        />
                    </CustomTd>
                    <CustomTd tableId={tableId} >
                        <CustomTooltip
                            text={item?.zoneName || EMPTY_VALUES.DEFAULT}
                            classes={`fs-14px font-color-general-950 text-ellipsis`}
                            showIfTruncated={true}
                        />
                    </CustomTd>

                </>
            );
        });

        return {
            body: body,
            data: results?.content
        }
    };

    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_UPDATE)) && (
                        <>
                            <DropDownMenuItem
                                index={index}
                                handleClose={handleClose}
                                name={t('open_door')}
                                click={() => {
                                    setItemOpenDoor(item);
                                    setOpenDoorShow(true);
                                }}
                                icon={<IconTitleEntryMethod/>}
                            />
                            <DropDownMenuItem
                                index={index}
                                handleClose={handleClose}
                                name={t('update')}
                                url={`${routes.devices.update}${item?.id}`}
                                icon={<UpdateIconsOptions/>}
                            />
                        </>
                    )}
                    <DropDownMenuItem
                        index={index}
                        handleClose={handleClose}
                        name={t('log')}
                        click={() => {
                            const data = {
                                id: item?.id,
                                name: item?.name,
                            };
                            setLogDevice(data);
                            setShowLogModal(true);
                        }}
                        icon={<IconFileLog/>}
                    />
                    {(DEV || permission?.includes(permissionObj?.WEB_DEVICE_DELETE)) && (
                        <DropDownMenuItem
                            id='btn_dp_delete'
                            index={index}
                            handleClose={handleClose}
                            name={t('delete')}
                            fontColor='font-color-error-600'
                            iconColor={"icon-color-error-code-600"}
                            click={() => {
                                setSelectedList([item?.id])
                                setDeleteDeviceShow(true);
                            }}
                            icon={<DeleteIconsOptions />}
                        />
                    )}
                </DropDownMenuProfile>
            </>
        );
    }

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({
            page: page,
            size: rowsPerPage,
            model: option,
            key: searchElement,
            view: VIEW_TYPE.LIST.viewType,
        });

        setBodyForExport(body);

        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    }


    const {
        thead,
        tbody,
        handleCheckboxChange,
        handleDeleteAll,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        rowsPerPage
    } = TableFunction({
        selectedList,
        setSelectedList,
        data:results,
        getThead,
        getTbody,
        labelRowsPerPage:'devices_per_page',
        fixedPagination: true,
        hasContainer:false,
        setIsAllChecked,
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        navigate,
        handleDeleteAll,
        deleteSelectedDevices,
        setBodyForExport,
        permission,
        DEV,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        contractorId,
        supplierId,
        showDeleteDeviceModal,
        setShowDeleteDeviceModal,
        modified,
        setModified,
        deleteDeviceShow,
        setDeleteDeviceShow,
        search,
        moduleId,
        option,
        bodyForExport,
        isAllChecked,
        tableId,
        searchId,
        thead,
        tbody,
        handleCheckboxChange,
        getActionsButtons,
        pagination,
        rowsPerPage,
        setResults,
        qrData,
        selectedList,
        showLogModal,
        setShowLogModal,
        logDevice,
        deletePermission,
        openDoorShow,
        setOpenDoorShow,
        itemOpenDoor

    }
};
